import { Link, Typography } from "@mui/material";

const Copyright = props => {
    return (
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          {...props}
        >
          {"Copyright © "}
          <Link color="inherit" href="https://devil1993.github.io">
            Samanway Ghatak - devil1993.github.io
          </Link>{" "}
          {new Date().getFullYear()}
          {"."}
        </Typography>
      );
}

export default Copyright;